import * as React from 'react';

interface IconProps {
	isHovered: boolean;
}

export function ClapIcon({ isHovered }: IconProps) {
	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<style>
				{`
					@keyframes clapOuter {
						0% { transform: rotate(0deg); }
						62.5% { transform: rotate(-10deg); }
						100% { transform: rotate(0deg); }
					}
					@keyframes clapInner {
						0% { transform: rotate(0deg); }
						30% { transform: rotate(-10deg); }
						60% { transform: rotate(16deg); }
						100% { transform: rotate(0deg); }
					}
					.clap-outer {
						transform-origin: 4px 20px;
						animation: ${isHovered ? 'clapOuter 0.8s ease-in-out infinite' : 'none'};
					}
					.clap-inner {
						transform-origin: 3px 11px;
						animation: ${isHovered ? 'clapInner 0.4s ease-in-out infinite' : 'none'};
					}
				`}
			</style>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				style={{ overflow: 'visible' }}
			>
				<g className="clap-outer">
					<g className="clap-inner">
						<path d='M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z' />
						<path d='m6.2 5.3 3.1 3.9' />
						<path d='m12.4 3.4 3.1 4' />
					</g>
					<path d='M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z' />
				</g>
			</svg>
		</div>
	);
}
